import Reviews from './Reviews';
import ReviewsItem from './ReviewsItem';
import ReviewsList from './ReviewsList';

export {
    Reviews,
    ReviewsList,
    ReviewsItem
};
